import { getAssetPath } from "@helpers/assets.helper";

export default {
	en: {
		openGraph: {
			url: 'https://www.anghami.com/investors',
			title: 'Investor Relations - Anghami',
			images: [
				{
					url: getAssetPath('investors/metas/investors-meta-en.png'),
					alt: 'Investor Relations - Anghami'
				}
			],
			site_name: 'Anghami'
		},
		twitter: {
			handle: '@anghami',
			site: '@anghami',
			cardType: 'summary_large_image'
		}
	},
	ar: {
		title: 'علاقات المستثمرين - أنغامي',
		canonical: 'https://www.anghami.com/investors',
		openGraph: {
			url: 'https://www.anghami.com/investors',
			title: 'علاقات المستثمرين - أنغامي',
			images: [
				{
					url: getAssetPath('investors/metas/investors-meta-ar.png'),
					alt: 'علاقات المستثمرين - أنغامي'
				}
			],
			site_name: 'Anghami'
		},
		twitter: {
			handle: '@anghami',
			site: '@anghami',
			cardType: 'summary_large_image'
		}
	},
	fr: {
		title: 'Relations avec les investisseurs - Anghami',
		canonical: 'https://www.anghami.com/investors',
		openGraph: {
			url: 'https://www.anghami.com/investors',
			title: 'Relations avec les investisseurs - Anghami',
			images: [
				{
					url: getAssetPath('investors/metas/investors-meta-fr.png'),
					alt: 'Relations avec les investisseurs - Anghami'
				}
			],
			site_name: 'Anghami'
		},
		twitter: {
			handle: '@anghami',
			site: '@anghami',
			cardType: 'summary_large_image'
		}
	}
};
